/**
 * Frischt die Glasflaeche des Headers auf, nachdem eine Schublade zu war.
 *
 * Beim Oeffnen des Menues sperrt das Theme das Scrollen: es setzt am
 * Dokument das Attribut scroll-lock, und damit steht overflow der Seite und
 * ihrer Huelle auf hidden. Beim Schliessen faellt beides wieder weg.
 *
 * Fuer Safari ist das mehr als ein Attribut: der Wechsel baut die
 * Zeichenebenen der Seite neu auf. Eine Flaeche mit backdrop-filter verliert
 * dabei ihren Untergrund - sie zeichnet danach nicht mehr den Inhalt hinter
 * sich weich, sondern nur noch die weisse Grundflaeche des Dokuments. Der
 * Header stand deshalb nach einem Blick ins Menue deckend weiss da, statt
 * durchscheinend.
 *
 * Der Ausweg ist unspektakulaer: die Flaeche wird gegen eine frische
 * ausgetauscht. Sie traegt keinen Inhalt und keinen Zustand - nur Farbe und
 * Weichzeichner aus dem Stilblatt -, ein Austausch kostet also nichts und
 * zwingt den Browser, die Ebene neu anzulegen. Wo der Fehler nicht auftritt,
 * faellt der Tausch nicht auf.
 */
const GLAS = '.dp-header-glas';

/** Nach dem Entsperren erst das Bild abwarten, in dem die Sperre faellt. */
function frischeAuf() {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const glas = document.querySelector(GLAS);
      if (!glas || !glas.parentElement) return;

      // Ohne Kinder und ohne Attribute ausser der Klasse - eine flache Kopie
      // genuegt.
      glas.replaceWith(glas.cloneNode(false));
    });
  });
}

function starte() {
  if (!document.querySelector(GLAS)) return;

  let warGesperrt = document.documentElement.hasAttribute('scroll-lock');

  const waechter = new MutationObserver(() => {
    const gesperrt = document.documentElement.hasAttribute('scroll-lock');
    if (warGesperrt && !gesperrt) frischeAuf();
    warGesperrt = gesperrt;
  });

  waechter.observe(document.documentElement, { attributes: true, attributeFilter: ['scroll-lock'] });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', starte, { once: true });
} else {
  starte();
}
